export default __webpack_public_path__ + "static/media/IMG5.454bf446.png";